import React from "react";
import { Container, Button, Header, Item, List, Grid, GridColumn, GridRow } from 'semantic-ui-react';
import { GoMarkGithub } from "react-icons/go";
import Wrapper from '../wrapper';
import Revita from '../../assets/images/revita.png';
import Burger from '../../assets/images/burger.png';
import Codequiz from '../../assets/images/codequiz.png';
import Planner from '../../assets/images/dayplanner.png';
import Finance from '../../assets/images/finance.png';
import Project1 from '../../assets/images/project1.png';
import Notes from '../../assets/images/notetaker.png';
import Password from '../../assets/images/password.png';
import Team from '../../assets/images/teamgenerator.png';
import Employee from '../../assets/images/employeetracker.png';
import Weather from '../../assets/images/weather2.png';
import Fitness from '../../assets/images/fitness.png';
import ReadMe from '../../assets/images/README.png';
import './style.css'

const buttonStyle = {
	background: '#ffdbef',
	color: '#363434',
	width: 125,
}

const gitStyle = {
	background: '#2a2a42',
	color: '#fff',
	width: 125,
}

const htmlBtn = {
	background: 'transparent',
	color: '#fff',
	width: 80,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const cssBtn = {
	background: 'transparent',
	color: '#fff',
	width: 80,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const javaBtn = {
	background: 'transparent',
	color: '#fff',
	width: 80,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const jqBtn = {
	background: 'transparent',
	color: '#fff',
	width: 80,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const mernBtn = {
	color: '#fff',
	background: 'transparent',
	width: 80,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const reactBtn = {
	color: '#fff',
	background: 'transparent',
	width: 80,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const mongoBtn = {
	color: '#fff',
	background: 'transparent',
	width: 120,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const passBtn = {
	color: '#fff',
	background: 'transparent',
	width: 120,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const semanticBtn = {
	color: '#fff',
	background: 'transparent',
	width: 120,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const edamamBtn = {
	color: '#fff',
	background: 'transparent',
	width: 130,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const spoonBtn = {
	color: '#fff',
	background: 'transparent',
	width: 150,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const materialBtn = {
	color: '#fff',
	background: 'transparent',
	width: 120,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const googleBtn = {
	color: '#fff',
	background: 'transparent',
	width: 170,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const domainBtn = {
	color: '#fff',
	background: 'transparent',
	width: 170,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const handleBtn = {
	color: '#fff',
	background: 'transparent',
	width: 120,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const sqlBtn = {
	color: '#fff',
	background: 'transparent',
	width: 90,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const nosqlBtn = {
	color: '#fff',
	background: 'transparent',
	width: 90,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const jestBtn = {
	color: '#fff',
	background: 'transparent',
	width: 70,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const morningBtn = {
	color: '#fff',
	background: 'transparent',
	width: 130,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const yahooBtn = {
	color: '#fff',
	background: 'transparent',
	width: 120,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const eslintBtn = {
	color: '#fff',
	background: 'transparent',
	width: 80,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const mongooseBtn = {
	color: '#fff',
	background: 'transparent',
	width: 110,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const expressBtn = {
	color: '#fff',
	background: 'transparent',
	width: 110,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const inquirerBtn = {
	color: '#fff',
	background: 'transparent',
	width: 90,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const weatherBtn = {
	color: '#fff',
	background: 'transparent',
	width: 170,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}

const momentBtn = {
	color: '#fff',
	background: 'transparent',
	width: 170,
	borderColor: '#fff',
	borderWidth: 1,
	borderStyle: 'solid',
}
function Project() {
	return (
		<Container className='container-projects main' >
			<Wrapper className='wrapper-projects'>
				<Header as='h2' textAlign='center'
					className="title center aligned header"> Projects</Header>
				<div className="projects-list" divided>
					<Grid columns={3}>

						<Grid.Row>
							<Grid.Column>
								<Item.Header className="project-titles header" as='a'>Revita U</Item.Header>
								<Item.Image className="project-image" size='medium' src={Revita} />
								<Item.Description className="project-description">A food substitution MERN application designed to encourage and promote healthier eating
								for users</Item.Description>
								<Button
									style={htmlBtn}>HTML
									</Button>
								<Button
									style={cssBtn}>CSS
								</Button>
								<Button
									style={javaBtn}>JS
								</Button>
								<Button
									style={mernBtn}>MERN
								</Button>
								<Button
									style={reactBtn}>React
								</Button>
								<Button
									style={mongoBtn}>Mongo DB
								</Button>
								<Button
									style={passBtn}>Passport.js
								</Button>
								<Button
									style={semanticBtn}>Semantic UI
								</Button>
								<Button
									style={materialBtn}>Material UI
								</Button>
								<Button
									style={edamamBtn}>Edamam API
								</Button>
								<Button
									style={spoonBtn}>Spoonacular API
								</Button>

								<div className="link-buttons">
									<Button
										style={buttonStyle}
										a href={"https://guarded-earth-77394.herokuapp.com/"}
										target="_blank" >App
									</Button>
									<Button style={gitStyle}
										a href={"https://github.com/barbara095/Revita-u"}
										target="_blank"
									>
										<GoMarkGithub
										>Github </GoMarkGithub>
									</Button>
								</div>
							</Grid.Column>

							<Grid.Column>
								<Item>
									<Item.Header className="project-titles header" as='a'>My dream Home</Item.Header>
									<Item.Image className="project-image" size='medium' src={Project1} />
									<Item.Content>
										<Item.Description className="project-description">An application designed to simplify and optimise the house hunting
                     journey to bring you the most relevant listings.</Item.Description>
										<Button
											style={htmlBtn}>HTML
									</Button>
										<Button
											style={cssBtn}>CSS
								</Button>
										<Button
											style={javaBtn}>JS
								</Button>
										<Button
											style={jqBtn}>jQuery
								</Button>
										<Button
											style={googleBtn}>Distance Matrix API
								</Button>
										<Button
											style={domainBtn}>Domain API
								</Button>
										<div className="link-buttons">
											<Button
												style={buttonStyle}
												a href={"https://bdcoelho.github.io/Project1/index.html"}
												target="_blank" >App
									</Button>
											<Button style={gitStyle}
												a href={"https://github.com/bdcoelho/Project1"}
												target="_blank"
											>
												<GoMarkGithub
												>Github</GoMarkGithub>
											</Button>
										</div>
									</Item.Content>
								</Item>
							</Grid.Column>

							<Grid.Column>
								<Item>
									<Item.Header className="project-titles header" as='a'>Team Profile Generator</Item.Header>
									<Item.Image className="project-image" size='medium' src={Team} />
									<Item.Content>
										<Item.Description className="project-description">A CLI application that generates a profile of your team!</Item.Description>
										<Button
											style={htmlBtn}>HTML
									</Button>
										<Button
											style={cssBtn}>CSS
								</Button>
										<Button
											style={javaBtn}>JS
								</Button>
										<Button
											style={jestBtn}>Jest
								</Button>
										<div className="link-buttons">
											<Button
												style={buttonStyle}
												a href={"https://drive.google.com/file/d/1qb3fogZEOd2BaxS129ipGzi1xCDQ10Ro/view?usp=sharing"}
												target="_blank" >App
									</Button>
											<Button style={gitStyle}
												a href={"https://github.com/barbara095/Team-Profile-Generator"}
												target="_blank"
											>
												<GoMarkGithub
												>Github </GoMarkGithub>
											</Button>
										</div>
									</Item.Content>
								</Item>
							</Grid.Column>
						</Grid.Row>

						<Grid.Row>
							<Grid.Column>
								<Item>
									<Item.Header className="project-titles header" as='a'>Eat Da Burger!</Item.Header>
									<Item.Image className="project-image" size='medium' src={Burger} />
									<Item.Content>
										<Item.Description className="project-description">A Node burger logger application that uses the MVC model to add, devour and remove
                  burgers!</Item.Description>
										<Button
											style={htmlBtn}>HTML
									</Button>
										<Button
											style={cssBtn}>CSS
								</Button>
										<Button
											style={javaBtn}>JS
								</Button>
										<Button
											style={handleBtn}>Handlebars
								</Button>
										<Button
											style={sqlBtn}>MySQL
								</Button>
										<div className="link-buttons">
											<Button
												style={buttonStyle}
												a href={"https://boiling-springs-85381.herokuapp.com/"} target="_blank" >App
									</Button>
											<Button style={gitStyle}
												a href={"https://github.com/barbara095/Node-Eat-Da-Burger"}
												target="_blank"
											>
												<GoMarkGithub
												>Github </GoMarkGithub>
											</Button>
										</div>
									</Item.Content>
								</Item>
							</Grid.Column>

							<GridColumn>
								<Item>
									<Item.Header className="project-titles header" as='a'>My Stock Pal</Item.Header>
									<Item.Image className="project-image" size='medium' src={Finance} />
									<Item.Content >
										<Item.Description className="project-description">A finance application that uses MySQL, Express and Node.js to allow users to add,
                  watch, buy and sell stocks</Item.Description>
										<Button
											style={htmlBtn}>HTML
									</Button>
										<Button
											style={cssBtn}>CSS
								</Button>
										<Button
											style={javaBtn}>JS
								</Button>
										<Button
											style={handleBtn}>Handlebars
								</Button>
										<Button
											style={sqlBtn}>MySQL
								</Button>
										<Button
											style={morningBtn}>Morningstar API
								</Button>
										<Button
											style={yahooBtn}>Yahoo Finance API
								</Button>
										<Button
											style={eslintBtn}>ESLint
								</Button>
										<div className="link-buttons">
											<Button
												style={buttonStyle}
												a href={"https://fast-lake-54569.herokuapp.com/userSummery"}
												target="_blank" >App
									</Button>
											<Button style={gitStyle}
												a href={"https://github.com/kube-consult/Project-2-trading-platform"}
												target="_blank"
											>
												<GoMarkGithub
												>Github </GoMarkGithub>
											</Button>
										</div>
									</Item.Content>
								</Item>
							</GridColumn>

							<GridColumn>
								<Item>
									<Item.Header className="project-titles header" as='a'>Fitness Tracker</Item.Header>
									<Item.Image className="project-image" size='medium' src={Fitness} />
									<Item.Content>
										<Item.Description className="project-description">An application that uses MongoDB to enable
                        a user to view, create and keep track of their workouts.</Item.Description>
										<Button
											style={htmlBtn}>HTML
									</Button>
										<Button
											style={cssBtn}>CSS
								</Button>
										<Button
											style={javaBtn}>JS
										</Button>
										<Button
											style={nosqlBtn}>NoSQL
										</Button>
										<Button
											style={mongoBtn}>Mongo DB
										</Button>
										<Button
											style={mongooseBtn}>Mongoose
										</Button>
										<div className="link-buttons">
											<Button
												style={buttonStyle}
												a href={"https://nameless-refuge-53137.herokuapp.com/"}
												target="_blank" >App
									</Button>
											<Button style={gitStyle}
												a href={"https://github.com/barbara095/NoSQL-Fitness-Tracker"}
												target="_blank"
											>
												<GoMarkGithub
												>Github </GoMarkGithub>
											</Button>
										</div>
									</Item.Content>
								</Item>
							</GridColumn>
						</Grid.Row>

						<Grid.Row>
							<Grid.Column>
								<Item>
									<Item.Header className="project-titles header" as='a'>Note Taker</Item.Header>
									<Item.Image className="project-image" size='medium' src={Notes} />
									<Item.Content>
										<Item.Description className="project-description">An Express Application that uses Node to write, save and delete notes!</Item.Description>
										<Button
											style={htmlBtn}>HTML
									</Button>
										<Button
											style={cssBtn}>CSS
								</Button>
										<Button
											style={javaBtn}>JS
										</Button>
										<Button
											style={expressBtn}>Express.js
										</Button>
										<div className="link-buttons">
											<Button
												style={buttonStyle}
												a href={"https://rocky-beach-44248.herokuapp.com/"}
												target="_blank" >App
									</Button>
											<Button style={gitStyle}
												a href={"https://github.com/barbara095/Express-Note-Taker"}
												target="_blank"
											>
												<GoMarkGithub
												>Github </GoMarkGithub>
											</Button>
										</div>
									</Item.Content>
								</Item>
							</Grid.Column>

							<GridColumn>
								<Item>
									<Item.Header className="project-titles header" as='a'>Employee Tracker</Item.Header>
									<Item.Image className="project-image" size='medium' src={Employee} />
									<Item.Content>
										<Item.Description className="project-description">Don't lose track of your employees with this Employee Management System that allows
                  you to add, update and remove employees, roles and departments using MySQL.</Item.Description>
										<Button
											style={javaBtn}>JS
										</Button>
										<Button
											style={inquirerBtn}>Inquirer
										</Button>
										<Button
											style={sqlBtn}>MySQL
								</Button>
										<div className="link-buttons">
											<Button
												style={buttonStyle}
												a href={"https://drive.google.com/file/d/10QKepTv7aqd8F3663eIP48RBgjXbRfRY/view"}
												target="_blank" >App
									</Button>
											<Button style={gitStyle}
												a href={"https://github.com/barbara095/MySQL-Employee-Tracker"}
												target="_blank"
											>
												<GoMarkGithub
												>Github </GoMarkGithub>
											</Button>
										</div>
									</Item.Content>
								</Item>
							</GridColumn>

							<GridColumn>
								<Item>
									<Item.Header className="project-titles header" as='a'>README Generator</Item.Header>
									<Item.Image className="project-image"  size='medium' src={ReadMe} />
									<Item.Content>
										<Item.Description className="project-description">A CLI application that generates a professional README.md file using node.js</Item.Description>
										<Button
											style={javaBtn}>JS
										</Button>
										<Button
											style={inquirerBtn}>Inquirer
										</Button>
										<div className="link-buttons">
											<Button
												style={buttonStyle}
												a href={"https://drive.google.com/file/d/1BQjPcuoJsPfD1er9SSBebo8AzbEnA-ju/view"}
												target="_blank" >App
									</Button>
											<Button style={gitStyle}
												a href={"https://github.com/barbara095/README-Generator"}
												target="_blank"
											>
												<GoMarkGithub
												>Github </GoMarkGithub>
											</Button>
										</div>
									</Item.Content>
								</Item>
							</GridColumn>
						</Grid.Row>

						<Grid.Row>
							<GridColumn>
								<Item>
									<Item.Header className="project-titles header" as='a'>Weather Dashboard</Item.Header>
									<Item.Image className="project-image" size='medium' src={Weather} />
									<Item.Content>
										<Item.Description className="project-description">An application using OpenWeather API that gives you a 5-day detailed weather overview for any city</Item.Description>
										<Button
											style={htmlBtn}>HTML
									</Button>
										<Button
											style={cssBtn}>CSS
								</Button>
										<Button
											style={javaBtn}>JS
										</Button>
										<Button
											style={weatherBtn}>Open Weather API
										</Button>
										<div className="link-buttons">
											<Button
												style={buttonStyle}
												a href={"https://barbara095.github.io/weather-dashboard-HW6/"}
												target="_blank" >App
									</Button>
											<Button style={gitStyle}
												a href={"https://github.com/barbara095/weather-dashboard-HW6"}
												target="_blank"
											>
												<GoMarkGithub
												>Github </GoMarkGithub>
											</Button>
										</div>
									</Item.Content>
								</Item>
							</GridColumn>

							<GridColumn>
								<Item>
									<Item.Header className="project-titles header" as='a'>The Ultimate Code Quiz</Item.Header>
									<Item.Image className="project-image" size='medium' src={Codequiz} />
									<Item.Content>
										<Item.Description className="project-description">Test your knowledge of full stack web development with this fun quiz.</Item.Description>
										<Button
											style={htmlBtn}>HTML
									</Button>
										<Button
											style={cssBtn}>CSS
								</Button>
										<Button
											style={javaBtn}>JS
								</Button>
										<div className="link-buttons">
											<Button
												style={buttonStyle}
												a href={"https://barbara095.github.io/code-quiz-HW4/"}
												target="_blank" >App
									</Button>
											<Button style={gitStyle}
												a href={"https://github.com/barbara095/code-quiz-HW4"}
												target="_blank"
											>
												<GoMarkGithub
												>Github </GoMarkGithub>
											</Button>
										</div>
									</Item.Content>
								</Item>
							</GridColumn>

							<GridColumn>
								<Item>
									<Item.Header className="project-titles header" as='a'>Password Generator</Item.Header>
									<Item.Image className="project-image" size='medium' src={Password} />
									<Item.Content>
										<Item.Description className="project-description">Protect your account and beat the hackers. Create a secure password with this
                  password generator.</Item.Description>
										<Button
											style={htmlBtn}>HTML
									</Button>
										<Button
											style={cssBtn}>CSS
								</Button>
										<Button
											style={javaBtn}>JS
								</Button>
										<div className="link-buttons">
											<Button
												style={buttonStyle}
												a href={"https://barbara095.github.io/password-generator-HW3/"}
												target="_blank" >App
									</Button>
											<Button style={gitStyle}
												a href={"https://github.com/barbara095/password-generator-HW3"}
												target="_blank"
											>
												<GoMarkGithub
												>Github </GoMarkGithub>
											</Button>
										</div>
									</Item.Content>
								</Item>
							</GridColumn>
						</Grid.Row>

						<GridColumn>
							<Item>
								<Item.Header className="project-titles header" as='a'>Work Day Planner</Item.Header>
								<Item.Image className="project-image" size='medium' src={Planner} />
								<Item.Content>
									<Item.Description className="project-description">Make your work day more organised with this simple work scheduler</Item.Description>
									<Button
										style={htmlBtn}>HTML
									</Button>
									<Button
										style={cssBtn}>CSS
								</Button>
									<Button
										style={javaBtn}>JS
								</Button>
									<Button
										style={momentBtn}>Moment.js
								</Button>
									<div className="link-buttons">
										<Button
											style={buttonStyle}
											a href={"https://barbara095.github.io/work-day-scheduler-HW5/"}
											target="_blank" >App
									</Button>
										<Button style={gitStyle}
											a href={"https://github.com/barbara095/work-day-scheduler-HW5"}
											target="_blank"
										>
											<GoMarkGithub
											>Github </GoMarkGithub>
										</Button>
									</div>
								</Item.Content>
							</Item>
						</GridColumn>

					</Grid>
				</div>
			</Wrapper>
		</Container>


	)
}

export default Project;